import { ReactNode } from "react";
import { Box, Stack, Typography } from "@mui/material";

interface IDashboardSectionGroupProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

// Agrupa varias DashboardSectionRow bajo un heading + subtítulo compartidos,
// tal como el diseño de Figma agrupa sub-paneles relacionados (ej. "Costos
// logísticos" con sus 3 sub-secciones). No maneja loading/error/empty ni
// proporciones de grid: eso sigue siendo responsabilidad de
// DashboardSectionContainer y DashboardSectionRow respectivamente.
//
// El gap vertical en Figma es uniforme: 24px entre el bloque de
// título+subtítulo y el contenido, y 24px entre cada Row subsiguiente. Un
// solo Stack spacing={3} (24px) resuelve ambos sin que nadie más agregue
// márgenes propios (por eso DashboardSectionContainer/Row no tienen mb).
const DashboardSectionGroup = ({
  title,
  subtitle,
  children,
}: IDashboardSectionGroupProps) => (
  <Stack spacing={3}>
    <Box>
      {/*
        Figma nombra esta capa "h2.text-sm": semánticamente un h2, pero de
        14px (no un heading grande) — igual que el "h3.text-sm" de
        DashboardSectionContainer. La jerarquía visual la da el peso/color,
        no el tamaño.
      */}
      <Typography
        variant="body2"
        fontWeight={700}
        color="text.primary"
        sx={{ fontSize: "0.875rem" }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" display="block">
          {subtitle}
        </Typography>
      )}
    </Box>
    {children}
  </Stack>
);

export default DashboardSectionGroup;
